import { userService } from "../../../services/user.service";
import { uploadService } from "../../../services/upload.service"
import { clearUser, getUsers, tempUser } from "../reducers/user.reducer";
import { setCurrentUser, setAuthenticated, setLoading, setError, setToken, setVersion, logout, setAccountTransition, setUserType, setImgUser } from "../reducers/auth.reducer";
import { setSelectedAccount, setMembersAccount, clearAccount } from "../../accounts/reducers/account.reducer";
import { dispatchMultipleActions } from "../../dispatchHelper";
import { clearDesktops, setDesktops } from "../../desktop/reducers/desktop.reducer";
import { clearBoards, loadBoard } from "../../board/reducers/board.reducer";
import { store } from '../../store.js';
import { connectSocket, disconnectSocket } from "../../../socket.listener/socket.js";
import { stripePaymentService } from "../../../services/stripe-payment.service";
import { resetTask } from "../../task/reducers/task.reducer.js";
import { resetGroup } from "../../group/reducers/group.reducer.js";
import { clearMarkedNotification } from "../../notifications/reducers/notifications.reducers.js";
import { setAdminOption, setLanguage, setNavType } from "../../layout/reducers/customization.reducer.js";
import { resetPlan, setPlan } from "../../plans/reducers/plan.reducer.js";
import { getPlanByAccountId } from "../../plans/actions/plan.actions.js";
import { addLogAccount, fetchAccount, getAccount } from "../../accounts/actions/account.actions.js";
import { userAvatarSrc } from "../../../services/util.service.js";

const dispatch = store.dispatch

// export async function login(credentials) {
//   try {
//     dispatch(setLoading(true));

//     const user = await userService.login(credentials);


//     if (user?.superUser) {
//       const userPayload = {
//         ...user.user,
//         isSuperUser: !!user.superUser
//       };
//       dispatchMultipleActions(
//         setCurrentUser(userPayload),
//         setAuthenticated(true),
//         setToken(user.token),
//       );
//     } else {
//       const plan = await getPlanByAccountId(user.user.accounts[0].accountId._id);
//       if (user?.user?.thema) {
//         dispatch(setNavType(user?.user?.thema));
//       }
//       dispatchMultipleActions(
//         setCurrentUser(user.user),
//         setAccount(user.user.accounts),
//         setSelectedAccount(user.user.accounts[0]),
//         setMembersAccount(user.user.accounts[0].accountId.users),
//         setPlan(plan),
//         setDesktops(user.user.accounts[0].accountId.desktops),
//         setAuthenticated(true),
//         setToken(user.token),
//         loadBoard()
//       );
//       connectSocket(user.user.accounts[0].accountId._id);

//       const field = {
//         action: 'user-login',
//         type: 'user',
//       };

//       await addLogAccount(user.user.accounts[0].accountId._id, field, user?.user?._id);
//     }
//   } catch (error) {
//     dispatchMultipleActions(
//       setError("Erro ao efetuar login " + error)
//     );

//     throw error;
//   } finally {
//     dispatch(setLoading(false));
//   }
// }

export async function login(credentials) {
  try {
    dispatch(setLoading(true));

    const response = await userService.login(credentials); // Renomeado para response para clareza
    const { user, token, superUser, currentAccount } = response;

    if (superUser) {
      const userPayload = {
        ...user,
        isSuperUser: !!superUser
      };
      dispatchMultipleActions(
        setCurrentUser(userPayload),
        setAuthenticated(true),
        setToken(token),
      );
    } else {
      // Verificar se o usuário tem accounts
      if (!user.accounts || user.accounts.length === 0) {
        throw new Error("Usuário não possui contas associadas");
      }

      // Usar o currentAccount retornado pela API, ou fallback para o primeiro account
      const selectedAccount = currentAccount || user.accounts[0].accountId;

      // Encontrar o account completo no array do usuário que corresponde ao selectedAccount
      const userAccountEntry = user.accounts.find(
        acc => String(acc.accountId?._id || acc.accountId) === String(selectedAccount?._id)
      );

      if (!userAccountEntry) {
        throw new Error("Account selecionada não encontrada nos dados do usuário");
      }

      // Buscar o plano usando o ID da account selecionada
      const plan = await getPlanByAccountId(selectedAccount?._id);

      // Aplicar tema se existir
      if (user?.thema) {
        dispatch(setNavType(user.thema));
      }

      // acha o vínculo desse usuário dentro do account
      const userInAccount = selectedAccount?.users.find(u =>
        String(u?.userId) === String(user?._id) ||
        String(u?.userId?._id) === String(user?._id) // caso userId venha populado como objeto
      );
      const userType = userInAccount?.typeUser ?? 3;
      const userImg = userInAccount?.imgURL ?? user?.imgURL;

      dispatchMultipleActions(
        setCurrentUser(user),
        setUserType(userType),
        setImgUser(userImg),
        setPlan(plan),
        setDesktops(selectedAccount?.desktops || []),
        setAuthenticated(true),
        setToken(token),
        loadBoard()
      );

      // buscar todas as informações corretas dos accounts no banco para não precisar encher o currentUser de informação desnecessária
      await fetchAccount(selectedAccount?._id);

      // Conectar socket com o ID da account selecionada
      connectSocket(selectedAccount?._id);

      const field = {
        action: 'user-login',
        type: 'user',
      };

      await addLogAccount(selectedAccount._id, field, user?._id);
    }
  } catch (error) {
    dispatchMultipleActions(
      setError("Erro ao efetuar login: " + error.message)
    );
    throw error;
  } finally {
    dispatch(setLoading(false));
  }
}

export async function loginWithGoogle({ idToken }) {
  try {
    dispatch(setLoading(true));

    const { user, token, superUser, currentAccount } = await userService.loginWithGoogle(idToken);

    if (superUser) {
      const userPayload = {
        ...user,
        isSuperUser: !!superUser
      };
      dispatchMultipleActions(
        setCurrentUser(userPayload),
        setAuthenticated(true),
        setToken(token),
      );
      return;
    }

    if (!user.accounts || user.accounts.length === 0) {
      throw new Error("Usuário não possui contas associadas");
    }

    const selectedAccount = currentAccount || user.accounts[0].accountId;

    // pegar a entry do array do usuário correspondente ao account selecionado
    const userAccountEntry = user.accounts.find(
      acc => String(acc.accountId?._id || acc.accountId) === String(selectedAccount?._id)
    );

    if (!userAccountEntry) {
      throw new Error("Account selecionada não encontrada nos dados do usuário");
    }
    const userInAccount = selectedAccount?.users.find(u =>
      String(u?.userId) === String(user?._id) ||
      String(u?.userId?._id) === String(user?._id) // caso userId venha populado como objeto
    );
    const userType = userInAccount?.typeUser ?? 3;
    const userImg = userInAccount?.imgURL ?? user?.imgURL;

    const plan = await getPlanByAccountId(selectedAccount?._id);
    if (user?.thema) {
      dispatch(setNavType(user?.thema));
    }
    dispatchMultipleActions(
      setCurrentUser(user),
      setSelectedAccount(userAccountEntry),
      setMembersAccount(selectedAccount?.users),
      setUserType(userType),
      setImgUser(userImg),
      setPlan(plan),
      setDesktops(selectedAccount?.desktops),
      setAuthenticated(true),
      setToken(token),
      loadBoard()
    );
    connectSocket(selectedAccount?._id);

    const field = {
      action: 'user-login',
      type: 'user',
    };

    await addLogAccount(selectedAccount?._id, field, user?._id);
    return { user, token, superUser, currentAccount };
  } catch (error) {
    dispatchMultipleActions(
      setError("Erro ao efetuar login com Google")
    );
    throw error;
  } finally {
    dispatch(setLoading(false));
  }
}

export async function changeAccount(user, selectedAccountId) {
  try {
    dispatch(setLoading(true));
    dispatch(setAccountTransition(true));

    // account atual
    const accountId = store.getState().accounts.selectedAccount?.accountId?._id;

    // logout da empresa antiga:
    if (accountId) {

      const fieldLogout = {
        action: 'user-logout',
        type: 'user',
      };
      await addLogAccount(accountId, fieldLogout, user?._id);

      // Encontrar o account completo no array do usuário que corresponde ao selectedAccount
      const userAccountEntry = user.accounts.find(
        acc => String(acc.accountId?._id || acc.accountId) === String(selectedAccountId)
      );

      if (!userAccountEntry) {
        throw new Error("Account selecionada não encontrada nos dados do usuário");
      }

      const selectedAccount = await fetchAccount(selectedAccountId);
      // Buscar o plano usando o ID da account selecionada
      const plan = await getPlanByAccountId(selectedAccountId);

      // acha o vínculo desse usuário dentro do account
      const userInAccount = selectedAccount?.users.find(u =>
        String(u?.userId) === String(user?._id) ||
        String(u?.userId?._id) === String(user?._id) // caso userId venha populado como objeto
      );
      const userType = userInAccount?.typeUser ?? 3;
      const userImg = userInAccount?.imgURL ?? user?.imgURL;

      dispatchMultipleActions(
        clearDesktops(),
        clearBoards(),
        resetTask(),
        resetGroup(),
        setCurrentUser(user),
        setPlan(plan),
        setUserType(userType),
        setImgUser(userImg),
        setDesktops(selectedAccount.desktops || []),
        setAuthenticated(true),
        loadBoard(),
      );

      disconnectSocket(accountId);
      // Conectar socket com o ID da account selecionada
      connectSocket(selectedAccountId);

      const fieldLogin = {
        action: 'user-login',
        type: 'user',
      };

      await addLogAccount(selectedAccountId, fieldLogin, user?._id);
    }
  } catch (error) {
    dispatchMultipleActions(
      setError("Erro ao trocar de conta: " + error.message),
      setAccountTransition(false)
    );
    throw error;
  } finally {
    dispatch(setLoading(false));
    dispatch(setAccountTransition(false));
  }
}

export async function doLogout() {
  try {
    const currentUser = store.getState().auth.currentUser;
    if (currentUser?.isSuperUser) {
      dispatchMultipleActions(
        logout(),
        clearAccount(),
        clearDesktops(),
        clearBoards(),
        resetTask(),
        resetGroup(),
        resetPlan(),
        clearMarkedNotification(),
        clearUser(),
        setLoading(false)
      );
    } else {
      const accountId = store.getState().accounts.selectedAccount?.accountId?._id;
      if (accountId && currentUser) {
        const field = {
          action: 'user-logout',
          type: 'user',
        };
        const payload = {
          userId: currentUser?._id,
          accountId
        }

        await userService.setLastAccountUser(payload);

        await addLogAccount(accountId, field, currentUser?._id);
        dispatchMultipleActions(
          logout(),
          clearAccount(),
          clearDesktops(),
          clearBoards(),
          resetTask(),
          resetGroup(),
          resetPlan(),
          clearMarkedNotification(),
          clearUser(),
          setLoading(false)
        );
        if (accountId) {
          disconnectSocket(accountId);
        }
      }
    }
  } catch (error) {
    dispatchMultipleActions(
      setLoading(false),
      setError("Erro ao efetuar logout " + error)
    );
    throw error;
  }
}
export async function setValueVersion(version) {
  dispatch(setVersion(version));
}

export async function signup(userData, accountDataToSend) {
  try {
    dispatchMultipleActions(setLoading(true));
    const data = await userService.signup(userData, accountDataToSend);
    return data;
  } catch (error) {
    dispatchMultipleActions(
      setLoading(false),
      setError(error.message)
    );
    throw error;
  }
}

export async function signupWithGoogle({ idToken }) {
  dispatch(setLoading(true));
  try {
    const { user, token, superUser, selectedAccount } =
      await userService.signupWithGoogle(idToken);

    const userInAccount = selectedAccount?.users.find(u =>
      String(u?.userId) === String(user?._id) ||
      String(u?.userId?._id) === String(user?._id) // caso userId venha populado como objeto
    );
    const userAccountEntry = user.accounts.find(
      acc => String(acc.accountId?._id || acc.accountId) === String(selectedAccount?._id)
    );

    if (!userAccountEntry) {
      throw new Error("Account selecionada não encontrada nos dados do usuário");
    }

    const userType = userInAccount?.typeUser ?? 3;
    const userImg = userInAccount?.imgURL ?? user?.imgURL;
    const plan = await getPlanByAccountId(selectedAccount?._id);
    if (user?.thema) {
      dispatch(setNavType(user?.thema));
    }
    dispatchMultipleActions(
      setCurrentUser({ ...user, isSuperUser: !!superUser }),
      setSelectedAccount(user?.accounts[0]),
      setSelectedAccount(userAccountEntry),
      setMembersAccount(selectedAccount?.users),
      setPlan(plan),
      setUserType(userType),
      setImgUser(userImg),
      setDesktops(selectedAccount?.desktops),
      setAuthenticated(true),
      setToken(token),
      loadBoard()
    );

    connectSocket(selectedAccount?._id);

    return { user, token, superUser };
  } catch (err) {
    console.log('erro ao cadastrar-se com o google', err);
    dispatch(setLoading(false));
    throw err;
  } finally {
    dispatch(setLoading(false));
  }
}


export async function setload(data) {
  dispatchMultipleActions(setLoading(data));
}

export async function invite(userData) {
  try {
    dispatchMultipleActions(setLoading(true));
    const sentEmail = await userService.invite(userData);
    return sentEmail;
  } catch (error) {
    dispatchMultipleActions(
      setLoading(false),
      setError(error.message)
    );
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}
export async function sendForgotPasswordEmail(email) {
  try {
    dispatchMultipleActions(setLoading(true));
    const response = await userService.forgotPassword(email);
    return response;
  } catch (error) {
    dispatchMultipleActions(
      setLoading(false),
      setError(error.message));
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}

export async function sendMentionEmail(payload) {
  try {
    dispatchMultipleActions(setLoading(true));
    const response = await userService.inviteMention(payload);
    return response;
  } catch (error) {
    dispatchMultipleActions(setLoading(false), setError(error.message));
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}

export async function verifyResetCode(email, code) {
  try {
    dispatchMultipleActions(setLoading(true));
    const response = await userService.verifyCode(email, code);
    return response;
  } catch (error) {
    dispatchMultipleActions(setLoading(false), setError(error.message));
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}

export async function sendEmailVerificationCode(email) {
  try {
    dispatchMultipleActions(setLoading(true));
    const response = await userService.forgotPassword(email, "signup");
    return response;
  } catch (error) {
    dispatchMultipleActions(
      setLoading(false),
      setError(error.message)
    );
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}

export async function verifyEmailVerificationCode(email, code) {
  try {
    dispatchMultipleActions(setLoading(true));
    const response = await userService.verifyCode(email, code, "signup");
    return response;
  } catch (error) {
    dispatchMultipleActions(setLoading(false), setError(error.message));
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}

export async function resetPassword(email, newPassword) {
  try {
    dispatchMultipleActions(setLoading(true));
    const response = await userService.resetPassword(email, newPassword);
    return response;
  } catch (error) {
    dispatchMultipleActions(setLoading(false), setError(error.message));
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}

export async function changePassword(userId, passwordData) {
  try {
    dispatchMultipleActions(setLoading(true));
    const response = await userService.changePassword(userId, passwordData);
    return response;
  } catch (error) {
    dispatchMultipleActions(setLoading(false), setError(error.message));
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}


export async function update(userData) {
  try {
    dispatchMultipleActions(setLoading(true));
    const user = await userService.update(userData);
    if (user) {
      dispatchMultipleActions(
        setCurrentUser(user),
      );
    }
    await findUsers();
    return user;
  } catch (error) {
    dispatchMultipleActions(
      setLoading(false),
      setError(error.message)
    );
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}

export async function findUsers() {
  try {
    const users = await userService.getUsers();
    dispatchMultipleActions(getUsers({ users }));
    return users;
  } catch (error) {
    dispatchMultipleActions(setError(error.message));
    throw error;
  }
}

export async function getAllUsersByAccount() {
  try {
    const accountId = store.getState().accounts.selectedAccount?.accountId?._id;
    const users = await userService.getUsersByAccount(accountId);
    return users;
  } catch (error) {
    console.log('erro ao buscar usuários da empresa:', error)
  }
}

export async function getTempUser(token) {
  try {
    const temp = await userService.getTempUser(token);
    dispatchMultipleActions(tempUser({ temp }));
    return temp;
  } catch (error) {
    dispatchMultipleActions(setError(error.message));
    throw error;
  }
}

export async function checkEmailExists(email) {
  try {
    dispatchMultipleActions(setLoading(true));
    const data = await userService.checkEmailExists(email);
    return data
  } catch (error) {
    dispatchMultipleActions(
      setLoading(false),
      setError(error.message)
    );
    throw error
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}

export async function verifyUserPassword(payload) {
  try {
    const data = await userService.verifyUserPassWord(payload);
    return data
  } catch (error) {
    console.error("Erro ao verificar senha:", error);
    throw error;
  }
}

export async function createUser(userData) {
  try {
    dispatchMultipleActions(setLoading(true));
    const data = await userService.createUser(userData);
    dispatchMultipleActions(setMembersAccount(data.updatedMembers));
    return data
  } catch (error) {
    dispatchMultipleActions(
      setLoading(false),
      setError(error.message)
    );
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}

export async function userAcceptInvite(userData) {
  try {
    dispatchMultipleActions(setLoading(true));
    const data = await userService.userAcceptInvite(userData);
    return data
  } catch (error) {
    dispatchMultipleActions(
      setLoading(false),
      setError(error.message)
    );
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}

export async function changeLngUser(currentUser, lng) {
  try {
    dispatchMultipleActions(setLoading(true));
    if (currentUser?._id) {
      dispatch(setLanguage(lng));
      const user = await userService.changeLng(currentUser?._id, lng);
      if (user) {
        dispatchMultipleActions(
          setCurrentUser(user),
        );
      }
    } else {
      dispatch(setLanguage(lng));
    }
    return;
  } catch (error) {
    dispatchMultipleActions(
      setLoading(false),
      setError(error.message)
    );
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}

export async function toggleShowGroups(userId, value) {
  try {
    dispatchMultipleActions(setLoading(true));
    if (userId) {
      const user = await userService.toggleShowGroupsWhitFilter(userId, value);
      if (user) {
        dispatchMultipleActions(
          setCurrentUser(user),
        );
      }
    }
    return;
  } catch (error) {
    dispatchMultipleActions(
      setLoading(false),
      setError(error.message)
    );
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}

export async function changeThemaUser(currentUser, newThema) {
  try {
    dispatchMultipleActions(setLoading(true));
    if (currentUser?._id) {
      dispatch(setNavType(newThema));
      const user = await userService.changeThema(currentUser?._id, newThema);
      if (user) {
        dispatchMultipleActions(
          setCurrentUser(user),
        );
      }
    } else {
      dispatch(setNavType(newThema));
    }
    return;
  } catch (error) {
    dispatchMultipleActions(
      setLoading(false),
      setError(error.message)
    );
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}


export async function changeFavoriteUser(userId, id, type) {
  try {
    dispatchMultipleActions(setLoading(true));
    const accountId = store.getState().accounts.selectedAccount?.accountId?._id;
    const data = await userService.favoriteUser(userId, id, type, accountId);
    if (data?.user) {
      dispatchMultipleActions(
        setCurrentUser(data?.user),
      );
    }
    return data?.action;
  } catch (error) {
    dispatchMultipleActions(
      setLoading(false),
      setError(error.message)
    );
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}

export async function checkFavoriteBoards(userId) {
  try {
    dispatchMultipleActions(setLoading(true));
    const accountId = store.getState().accounts.selectedAccount?.accountId?._id;
    const data = await userService.checkFavoriteUser(accountId, userId);

    if (data?.user && data?.countRemoved > 0) {
      dispatchMultipleActions(
        setCurrentUser(data?.user),
      );
    }
    return data?.ok;
  } catch (error) {
    dispatchMultipleActions(
      setLoading(false),
      setError(error.message)
    );
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}


export async function editBoardsFavoriteUser(userId, accountId, boards) {
  try {
    dispatchMultipleActions(setLoading(true));
    const data = await userService.editFavoriteUser(accountId, userId, boards);
    if (data?.user) {
      dispatchMultipleActions(
        setCurrentUser(data?.user),
      );
    }
    return data?.action;
  } catch (error) {
    dispatchMultipleActions(
      setLoading(false),
      setError(error.message)
    );
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}

export async function changeFilterTask(data, userId) {
  try {
    dispatchMultipleActions(setLoading(true));

    const payload = { ...data };

    if (!Array.isArray(payload.filters) || payload.filters.length === 0) {
      if (payload.filter) {
        payload.filters = [payload.filter];
        delete payload.filter;
      }
    }

    const user = await userService.filteredTaskCard(payload, userId);

    if (user) {
      dispatchMultipleActions(setCurrentUser(user));
    }
    return;
  } catch (error) {
    dispatchMultipleActions(
      setLoading(false),
      setError(error.message)
    );
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}


export async function setTempEmail(data) {
  try {
    dispatchMultipleActions(
      setLoading(true),
      tempUser({ temp: data })
    );
  } catch (error) {
    dispatchMultipleActions(
      setLoading(false),
      setError(error.message)
    );
    throw error;
  } finally {
    dispatchMultipleActions(setLoading(false));
  }
}

export async function uploadImgUser(data, user, members) {
  try {
    dispatch(setLoading(true));

    const BASE_URL = process.env.REACT_APP_BASE_URL_BACKEND?.replace(/\/+$/, '');
    const accountId = store.getState().accounts.selectedAccount?.accountId?._id;
    const response = await uploadService.uploadUserImg(data, user._id, accountId);
    const userUpdated = {
      ...user,
      imgURL: response.secure_url,
    };

    const updateUser = await userService.update(userUpdated, accountId);
    const avatarUrl = userAvatarSrc({
      imgURL: response.secure_url,
      BASE_URL,
      accountId,
      folder: "profile-pictures",
      version: updateUser?.updatedAt
    });
    dispatchMultipleActions(
      //setCurrentUser(updateUser),
      setImgUser(avatarUrl)
    );
    return response;
  } catch (error) {
    dispatch(setLoading(false));
    throw error;
  } finally {
    dispatch(setLoading(false));
  }
}

export async function getUrlImgUser(userId) {
  try {
    const url = await userService.getImgUrl(userId)
    return url
  } catch (error) {
    throw error
  }
}

export async function stripePayment(cardNumber, cardExpiryElement, cardCvc, cardClientName, amount) {
  try {
    dispatch(setLoading(true));

    const paymentReturn = await stripePaymentService.paymentIntent(cardNumber, cardExpiryElement, cardCvc, cardClientName, amount);
    return paymentReturn;
  } catch (error) {
    dispatch(setLoading(false));
    throw error
  } finally {
    dispatch(setLoading(false));
  }
}

export async function updateUserRole(userId, newRole) {
  try {
    const accountId = store.getState().accounts.selectedAccount?.accountId?._id;

    dispatch(setLoading(true));
    await userService.updateUserRole(userId, accountId, newRole);

    return;
  } catch (error) {
    dispatch(setError(`Failed to update role: ${error.message}`));
    throw error;
  } finally {
    dispatch(setLoading(false));
  }
}

export async function updateUserType(type) {
  try {
    dispatch(setUserType(type))
    return;
  } catch (error) {
    dispatch(setError(`Failed to update role: ${error.message}`));
    throw error;
  }
}


export async function updateUserStatus(userId, newStatus) {
  try {
    dispatch(setLoading(true));

    const accountId = store.getState().accounts.selectedAccount?.accountId?._id;
    await userService.updateUserStatus(userId, accountId, newStatus);
    return;
  } catch (error) {
    dispatch(setError(error.message));
    throw error;
  } finally {
    dispatch(setLoading(false));
  }
}

export async function updatePasswordUser(userId, passwordData, accountId) {
  try {
    dispatch(setLoading(true));
    const updatedUser = await userService.updateUserPassWord(userId, passwordData, accountId);
    return updatedUser;
  } catch (error) {
    dispatch(setError(error.message));
    throw error;
  } finally {
    dispatch(setLoading(false));
  }
}


export function changeOption(option, isAdmin) {
  if (isAdmin) {
    dispatch(setAdminOption(option));
  }
  //else {
  //   dispatch(setAdminOption(option));
  // }
}

export async function getInviteLink(email) {
  try {
    dispatch(setLoading(true));
    const linkToken = await userService.getLinkTokenInvite(email);
    return linkToken;
  }
  catch (err) {
    console.log('erro ao buscar token invite');
    dispatch(setLoading(false));
    throw err;
  } finally {
    dispatch(setLoading(false));
  }
}


export async function canShowTutorial(userId) {
  try {
    const user = await userService.canShowTutorial(userId);
    if (user) {
      dispatchMultipleActions(
        setCurrentUser(user)
      );
    }
    return user?.tutorial;
  } catch (error) {
    console.log('erro ao verificar exibição do tutorial');
  }
}

export async function updateTutorialUser(show, step) {
  try {
    const userId = store.getState().auth.currentUser?._id;
    const user = await userService.updateTutorial(userId, show, step);
    if (user) {
      dispatchMultipleActions(
        setCurrentUser(user)
      );
    }
    return user?.tutorial;
  } catch (error) {
    console.log('erro ao atualizar tutorial');
  }
}
